// import { __getComment } from "./redux/modules/comments";
// import { useDispatch, useSelector } from "react-redux";

import React from "react";
import Router from "./shared/router";

import "./App.css";

export default function App() {
  return <Router />;
}
